import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApiWorkflowConstants } from "../../../../shared/constants/api-constants/api-workflow.constants";
export class StepMetadataConstants {
    static STEP_TITLE = "Step metadata";
    static ADMIN_PERMISSION_ERROR = `${SharedConstants.FORBIDDEN_MESSAGE}`;
    static METADATA_REQUIRED = `Metadata ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`;
    static METADATA_VALID = `Metadata ${SharedConstants.INVALID_INPUT_CONTROL_VALIDATION}`;
    static WORKFLOWSTEPNAME_URL = `${ApiWorkflowConstants.URL}/${ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_STEP_NAMES}`;
    static SUBSTRING_ZERO = "stepName eq";
    static AND_MODULE_ID = "AND moduleId eq";
    static METADATA_TEXT = "Metadata";
    static SCHEMA_TEXT = "SCHEMA";
    static WORKFLOW_STEPS_TEXT = "workflow steps";
    static MODULE_USERS_TEXT = "module users";
    static MODULE_ROLES_TEXT = "module roles";
    static SCHEMA_FILED_ASSIGNED_USER_ROLE = "defaultAssignedUserOrRole";
    static SCHEMA_FILED_DEFAULT_USER = "defaultUser";
    static SCHEMA_FILED_DEFAULT_ROLE = "defaultRole";
    static REFRESH_LABEL = "Refresh";
    static VALIDATE_LABEL = "Validate step metadata";
    static VALIDATION_ERRORS_LABEL = "Validation result";
    static DUPLICATE_STEPNAMES = "Duplicate step names exist for this module";
    static STEPNAME_NOT_FOUND = "Step name not found";
    static IS_VALID = "Valid";
    static EXPORT_METADATA = "Backup";
    static IMPORT_METADATA = "Restore";
    static METADATA_IMPORTED_SUCCESSFULLY = "Metadata restored successfully";
}
